// Ported from dev-scrips-pm-react services/scheduling/use-prebook-selected-slot.ts (PROD-1190 calendar port)
import { useMutation } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';
import type { PreBookAppointmentProfileResponse } from './use-prebook-appointment-profile';

/**
 * POST /api/v1/Practice/PreBookSelectedSlot
 *
 * Mirrors Flutter `scheduling_data_source_impl.dart:838–867`. Fired
 * after a slot is picked from the full Time & Date sub-page (NOT the
 * inline slot picker). Refreshes the reminder / billing / RFV context
 * for the new slot. Body shape:
 *   { organizationId, practiceId, appointmentProfileId, providerId }
 *
 * Response mirrors PreBookSelectedAppointmentProfile so we reuse the
 * same TypeScript shape.
 */

interface PreBookSlotParams {
  organizationId: string;
  practiceId: string;
  /** Master profile id — Flutter uses `appointmentProfile.referenceId`. */
  appointmentProfileId: string;
  providerId: string;
}

export function usePreBookSelectedSlot() {
  return useMutation<PreBookAppointmentProfileResponse, Error, PreBookSlotParams>({
    mutationFn: (params) => {
      return post<PreBookAppointmentProfileResponse>(
        '/api/v1/Practice/PreBookSelectedSlot',
        {
          organizationId: params.organizationId,
          practiceId: params.practiceId,
          appointmentProfileId: params.appointmentProfileId,
          providerId: params.providerId,
        },
      );
    },
  });
}
